import { render, staticRenderFns } from "./editSalesman.vue?vue&type=template&id=df8fc7f2&scoped=true&"
import script from "./editSalesman.vue?vue&type=script&lang=js&"
export * from "./editSalesman.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df8fc7f2",
  null
  
)

export default component.exports